<template>
    <b-container class="pb-5 mb-5 flex-1">
        <b-row class="mt-5 mb-5">
            <b-col>
                <h2>Organizations</h2>
            </b-col>

            <b-col class="text-right">
                <b-button variant="success" :to="{name: 'admin-new-org'}"><i class="fas fa-plus-circle mr-2"></i>New Organization</b-button>
            </b-col>
        </b-row>

        <b-card class="conference mb-3" v-for="org in organizations">
            <b-row>
                <b-col cols="7">
                    <h6>{{org.title}} <b-badge variant="light" class="ml-3"><i class="fas fa-tag mr-2"></i>{{org.role}}</b-badge></h6>
                    <div><strong>{{org.conferences.length}}</strong> Conferences</div>
                    <div class="text-muted">{{org.created_at | moment('MMMM Do, YYYY')}}</div>
                </b-col>
                <b-col class="text-right">
                    <b-button variant="success" class="mr-2" :to="{name: 'admin-org-details', params: {id: org.id}}"><i class="fas fa-search mr-2"></i> Details</b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "admin-dashboard",
        data() {
            return {
                organizations: []
            }
        },
        methods: {
            ...mapActions(['getOrganizations'])
        },
        mounted: function() {
            this.getOrganizations().then(orgs => {
                this.organizations = orgs;
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .text-muted {
        font-size: 0.8rem;
    }
</style>
